import React, {useCallback, useState, useEffect} from 'react';
import Camera from './camera/Camera';
import Prediction from './prediction/Prediction';
import ImageSelectorButton from './staticImage/ImageSelectorButton';
import StaticImage from './staticImage/StaticImage';
import Dropzone from 'react-dropzone'
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import ModelWorker from "workerize-loader!../model/worker";

const modelWorker = ModelWorker();
// the filepaths to our exported signature.json and model.json files (in the public/model folder)
const signatureFile = process.env.PUBLIC_URL + `/model/signature.json`;
const modelFile = process.env.PUBLIC_URL + `/model/model.json`;
function App() {
    // state for keeping track of our predictions -- map of {label: confidence} from running the model on an image
    const [predictions, setPredictions] = useState<{[key: string]: number} | undefined>(undefined);
    // state for using a static image from file picker
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [modelLoaded, setModelLoaded] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(()=>{
        async function getModel(){
            console.log("loading model")
            // create our web worker instance for running the tfjs model without blocking the UI thread

// load our model in the web worker
            await modelWorker.loadModel(signatureFile, modelFile);
            setModelLoaded(true);
            console.log("model loaded ", modelWorker)
        }
        if (!modelLoaded) {
            getModel()
        }

    }, [modelLoaded])
    // function to run the image from an html canvas element through our model
    const predictCanvas = useCallback((canvas: HTMLCanvasElement) => {
        // get the canvas context
        const ctx = canvas.getContext('2d');
        if (ctx) {
            setLoading(true);
            // get the pixel data from the full canvas
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            // run the async predict function and set the values to our state
            modelWorker.predict(imageData).then((results: {Confidences: {[label: string]: number}}) => {
                if (results) {
                    setPredictions(results.Confidences);
                }
                setLoading(false);
            });
        }
    }, []);

    if (!modelLoaded) {
        return(
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", justifyItems: "center"}}>
                <img src={"/img.png"} style={{height: 150, objectFit: "contain"}}/>
                <h1>Loading model. Please wait about 30 seconds...</h1>
            </div>
        )
    }
    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", justifyItems: "center"}}>
            <img src={"/img.png"} style={{height: 150, objectFit: "contain"}}/>
            <h3>Welcome to Exocetus' Marine Mammal Avoidance Demonstrator</h3>
            <h4>This model is trained on whales, dolphins, coral reefs, and divers.</h4>
            {
                predictions && (
                    <button onClick={()=>{
                        setImageFile(null)
                        setPredictions(undefined)
                    }}>Clear Image</button>
                )
            }
            {
                imageFile ? (<StaticImage predictCanvas={predictCanvas} image={imageFile} setImageFile={setImageFile} />) : (
                    <Dropzone onDrop={acceptedFiles => setImageFile(acceptedFiles[0])}>
                        {({getRootProps, getInputProps}) => (
                            <section>
                                <div {...getRootProps()} style={{marginTop: 50, height: 400, borderStyle: "dotted"}}>
                                    <input {...getInputProps()} />
                                    <p>Drag 'n' drop a picture here and the model will try to predict.</p>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                )
            }

            {
                imageFile && (
                    <Prediction predictions={predictions} loading={loading}/>
                )
            }




        </div>
    );
}

export default App;
